// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEnum$dGeneric from "../Data.Enum.Generic/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dEnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic$dForm$dTestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble$dEnum from "../Unscramble.Enum/index.js";
const $VatRate = tag => ({tag});
const VatAIsSymbol = {reflectSymbol: () => "VatA"};
const VatBIsSymbol = {reflectSymbol: () => "VatB"};
const VatCIsSymbol = {reflectSymbol: () => "VatC"};
const VatDIsSymbol = {reflectSymbol: () => "VatD"};
const VatEIsSymbol = {reflectSymbol: () => "VatE"};
const VatFIsSymbol = {reflectSymbol: () => "VatF"};
const VatGIsSymbol = {reflectSymbol: () => "VatG"};
const genericTopConstructor = {"genericTop'": Data$dGeneric$dRep.NoArguments};
const genericBottomConstructor = {"genericBottom'": Data$dGeneric$dRep.NoArguments};
const genericBottomSum = {"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)};
const genericEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments);
const genericEnumSum = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(genericEnumConstructor)(genericTopConstructor);
const genericEnumSum1 = /* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(genericEnumConstructor)(genericBottomConstructor))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum);
const genericBoundedEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments);
const genericBoundedEnumSum = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumSum(genericBoundedEnumConstructor);
const genericBoundedEnumSum1 = /* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(genericBoundedEnumConstructor))))));
const VatA = /* #__PURE__ */ $VatRate("VatA");
const VatB = /* #__PURE__ */ $VatRate("VatB");
const VatC = /* #__PURE__ */ $VatRate("VatC");
const VatD = /* #__PURE__ */ $VatRate("VatD");
const VatE = /* #__PURE__ */ $VatRate("VatE");
const VatF = /* #__PURE__ */ $VatRate("VatF");
const VatG = /* #__PURE__ */ $VatRate("VatG");
const eqVatRate = {
  eq: x => y => {
    if (x.tag === "VatA") { return y.tag === "VatA"; }
    if (x.tag === "VatB") { return y.tag === "VatB"; }
    if (x.tag === "VatC") { return y.tag === "VatC"; }
    if (x.tag === "VatD") { return y.tag === "VatD"; }
    if (x.tag === "VatE") { return y.tag === "VatE"; }
    if (x.tag === "VatF") { return y.tag === "VatF"; }
    if (x.tag === "VatG") { return y.tag === "VatG"; }
    return false;
  }
};
const ordVatRate = {
  compare: x => y => {
    if (x.tag === "VatA") {
      if (y.tag === "VatA") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "VatA") { return Data$dOrdering.GT; }
    if (x.tag === "VatB") {
      if (y.tag === "VatB") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "VatB") { return Data$dOrdering.GT; }
    if (x.tag === "VatC") {
      if (y.tag === "VatC") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "VatC") { return Data$dOrdering.GT; }
    if (x.tag === "VatD") {
      if (y.tag === "VatD") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "VatD") { return Data$dOrdering.GT; }
    if (x.tag === "VatE") {
      if (y.tag === "VatE") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "VatE") { return Data$dOrdering.GT; }
    if (x.tag === "VatF") {
      if (y.tag === "VatF") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "VatF") { return Data$dOrdering.GT; }
    if (x.tag === "VatG") {
      if (y.tag === "VatG") { return Data$dOrdering.EQ; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqVatRate
};
const genericVatRate = {
  to: x => {
    if (x.tag === "Inl") { return VatA; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return VatB; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return VatC; }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return VatD; }
          if (x._1._1._1.tag === "Inr") {
            if (x._1._1._1._1.tag === "Inl") { return VatE; }
            if (x._1._1._1._1.tag === "Inr") {
              if (x._1._1._1._1._1.tag === "Inl") { return VatF; }
              if (x._1._1._1._1._1.tag === "Inr") { return VatG; }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "VatA") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "VatB") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "VatC") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
    if (x.tag === "VatD") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))));
    }
    if (x.tag === "VatE") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
      );
    }
    if (x.tag === "VatF") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
        )
      );
    }
    if (x.tag === "VatG") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))))
        )
      );
    }
    $runtime.fail();
  }
};
const showVatRate = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(VatAIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(VatBIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(VatCIsSymbol);
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(VatDIsSymbol);
    const $4 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(VatEIsSymbol);
    const $5 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(VatFIsSymbol);
    const $6 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(VatGIsSymbol);
    return x => {
      const $7 = genericVatRate.from(x);
      if ($7.tag === "Inl") { return $0["genericShow'"]($7._1); }
      if ($7.tag === "Inr") {
        if ($7._1.tag === "Inl") { return $1["genericShow'"]($7._1._1); }
        if ($7._1.tag === "Inr") {
          if ($7._1._1.tag === "Inl") { return $2["genericShow'"]($7._1._1._1); }
          if ($7._1._1.tag === "Inr") {
            if ($7._1._1._1.tag === "Inl") { return $3["genericShow'"]($7._1._1._1._1); }
            if ($7._1._1._1.tag === "Inr") {
              if ($7._1._1._1._1.tag === "Inl") { return $4["genericShow'"]($7._1._1._1._1._1); }
              if ($7._1._1._1._1.tag === "Inr") {
                if ($7._1._1._1._1._1.tag === "Inl") { return $5["genericShow'"]($7._1._1._1._1._1._1); }
                if ($7._1._1._1._1._1.tag === "Inr") { return $6["genericShow'"]($7._1._1._1._1._1._1); }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeVatRate = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericVatRate)(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsConstruct(VatAIsSymbol))(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsConstruct(VatBIsSymbol))(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsConstruct(VatCIsSymbol))(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsConstruct(VatDIsSymbol))(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsConstruct(VatEIsSymbol))(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsConstruct(VatFIsSymbol))(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsConstruct(VatGIsSymbol))))))))(Unscramble$dEnum.defaultEnumOptions)
};
const boundedVatRate = /* #__PURE__ */ (() => (
  {
    top: genericVatRate.to(Data$dGeneric$dRep.$Sum(
      "Inr",
      Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))))
      )
    )),
    bottom: genericVatRate.to(Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)),
    Ord0: () => ordVatRate
  }
))();
const enumVatRate = {
  succ: /* #__PURE__ */ Data$dEnum$dGeneric.genericSucc(genericVatRate)(genericEnumSum1),
  pred: /* #__PURE__ */ Data$dEnum$dGeneric.genericPred(genericVatRate)(genericEnumSum1),
  Ord0: () => ordVatRate
};
const boundedEnumVatRate = /* #__PURE__ */ (() => (
  {
    cardinality: genericBoundedEnumSum1["genericCardinality'"],
    toEnum: Data$dEnum$dGeneric.genericToEnum(genericVatRate)(genericBoundedEnumSum1),
    fromEnum: x => genericBoundedEnumSum1["genericFromEnum'"](genericVatRate.from(x)),
    Bounded0: () => boundedVatRate,
    Enum1: () => enumVatRate
  }
))();
const toFillFormTypeVatRate = {
  fillFormDataType: /* #__PURE__ */ Restaumatic$dForm$dTestHelpers.defaultEnumFillFormDataType(genericVatRate)(/* #__PURE__ */ Restaumatic$dForm$dTestHelpers.gEnumToFillFormTypeSum({
    gdefaultEnumFillFormDataType: v => "\"VatA\""
  })(/* #__PURE__ */ Restaumatic$dForm$dTestHelpers.gEnumToFillFormTypeSum({gdefaultEnumFillFormDataType: v => "\"VatB\""})(/* #__PURE__ */ Restaumatic$dForm$dTestHelpers.gEnumToFillFormTypeSum({
    gdefaultEnumFillFormDataType: v => "\"VatC\""
  })(/* #__PURE__ */ Restaumatic$dForm$dTestHelpers.gEnumToFillFormTypeSum({gdefaultEnumFillFormDataType: v => "\"VatD\""})(/* #__PURE__ */ Restaumatic$dForm$dTestHelpers.gEnumToFillFormTypeSum({
    gdefaultEnumFillFormDataType: v => "\"VatE\""
  })(/* #__PURE__ */ Restaumatic$dForm$dTestHelpers.gEnumToFillFormTypeSum({gdefaultEnumFillFormDataType: v => "\"VatF\""})({gdefaultEnumFillFormDataType: v => "\"VatG\""})))))))
};
const encodeVatRate = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumEncode(genericVatRate)({
    encodeEnum: v => v1 => {
      if (v1.tag === "Inl") { return v.constructorTagTransform("VatA"); }
      if (v1.tag === "Inr") {
        if (v1._1.tag === "Inl") { return v.constructorTagTransform("VatB"); }
        if (v1._1.tag === "Inr") {
          if (v1._1._1.tag === "Inl") { return v.constructorTagTransform("VatC"); }
          if (v1._1._1.tag === "Inr") {
            if (v1._1._1._1.tag === "Inl") { return v.constructorTagTransform("VatD"); }
            if (v1._1._1._1.tag === "Inr") {
              if (v1._1._1._1._1.tag === "Inl") { return v.constructorTagTransform("VatE"); }
              if (v1._1._1._1._1.tag === "Inr") {
                if (v1._1._1._1._1._1.tag === "Inl") { return v.constructorTagTransform("VatF"); }
                if (v1._1._1._1._1._1.tag === "Inr") { return v.constructorTagTransform("VatG"); }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
  })
};
const decodeVatRate = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumDecode(genericVatRate)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(VatAIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(VatBIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(VatCIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(VatDIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(VatEIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(VatFIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(VatGIsSymbol))))))))
};
export {
  $VatRate,
  VatA,
  VatAIsSymbol,
  VatB,
  VatBIsSymbol,
  VatC,
  VatCIsSymbol,
  VatD,
  VatDIsSymbol,
  VatE,
  VatEIsSymbol,
  VatF,
  VatFIsSymbol,
  VatG,
  VatGIsSymbol,
  boundedEnumVatRate,
  boundedVatRate,
  decodeVatRate,
  encodeVatRate,
  enumVatRate,
  eqVatRate,
  genericBottomConstructor,
  genericBottomSum,
  genericBoundedEnumConstructor,
  genericBoundedEnumSum,
  genericBoundedEnumSum1,
  genericEnumConstructor,
  genericEnumSum,
  genericEnumSum1,
  genericTopConstructor,
  genericVatRate,
  ordVatRate,
  showVatRate,
  toFillFormTypeVatRate,
  unscrambleDecodeVatRate
};
